<div class="json-formatter-row">
  <span *ngIf="objectName !== 'Object' && objectName !== 'Array'" (click)="addKeyToExtractor(key)" class="clickable"> + </span>
  <a (click)="toggleOpen()">
    <i class="fas clickable" [ngClass]="isOpen ? 'fa-angle-down' : 'fa-angle-right'" *ngIf="isJsonObject() || isJsonArray()"> </i>
    <span class="key" *ngIf="hasKey">
      <span class="key-text"> {{ key }} </span>
      <span class="colon"> : </span>
    </span>
    <span class="value">
      <span *ngIf="isJsonObject() || isJsonArray()">
        <span class="constructor-name">{{ objectName }}</span>
        <span *ngIf="isJsonArray()">
          <span class="bracket"> [</span>
          <span class="number">{{ json.length }}</span>
          <span class="bracket">]</span>
        </span>
      </span>
      <span *ngIf="!isJsonObject() && !isJsonArray()" (click)="openLink(isUrl)" class="{{ type }}" [ngClass]="{ date: isDate, url: isUrl }">{{ value }}</span>
    </span>
  </a>
  <div class="children" *ngIf="getKeys().length && isOpen">
    <app-response-formatter
      *ngFor="let jkey of getKeys()"
      [json]="json[jkey]"
      [key]="jkey"
      [path]="path"
      [parentType]="objectName"
      [open]="childrenOpen()"
      (emitor)="emitToParent($event)"
    ></app-response-formatter>
  </div>
  <div class="children empty object" *ngIf="isEmptyObject()"></div>
  <div class="children empty array" *ngIf="getKeys() && !getKeys().length && isOpen && isJsonArray()"></div>
</div>
